import {CheckoutGateway} from '../classes';
import cart from '@ppcp/cart';
import Actions from '@ppcp/actions';
import {isPluginConnected} from '@ppcp/utils';

if (isPluginConnected()) {
    const checkout = new CheckoutGateway(
        cart,
        {id: 'ppcp', actions: new Actions(), context: 'checkout'}
    );

    setInterval(() => {
        if (checkout.paypal) {
            checkout.createButton();
        }
    }, 2000);
}